import API_ROUTES from '../api/apiUri';

const decodeBase64Url = (value) => {
  if (!value) {
    return '';
  }

  const normalizedValue = value.replace(/-/g, '+').replace(/_/g, '/');
  const padding = normalizedValue.length % 4;
  const paddedValue = padding
    ? normalizedValue + '='.repeat(4 - padding)
    : normalizedValue;

  if (typeof window !== 'undefined' && typeof window.atob === 'function') {
    return window.atob(paddedValue);
  }

  if (typeof Buffer !== 'undefined') {
    return Buffer.from(paddedValue, 'base64').toString('utf8');
  }

  return '';
};

export const parseJwtPayload = (token) => {
  if (!token || typeof token !== 'string') {
    return null;
  }

  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  try {
    const payload = decodeBase64Url(parts[1]);
    return payload ? JSON.parse(payload) : null;
  } catch {
    return null;
  }
};

export const getSessionTimeoutDelay = (token, now = Date.now()) => {
  const payload = parseJwtPayload(token);
  const expirySeconds = payload?.exp;

  if (typeof expirySeconds !== 'number') {
    return null;
  }

  const expiryTime = expirySeconds * 1000;
  return Math.max(expiryTime - now, 0);
};

export const clockOutSession = async ({
  token = null,
  logoutUrl = API_ROUTES.employee.employee_logout,
} = {}) => {
  if (!logoutUrl) {
    return { ok: false, skipped: true };
  }

  const storedToken = typeof sessionStorage !== 'undefined'
    ? sessionStorage.getItem('appToken') || sessionStorage.getItem('msalToken')
    : null;
  const accessToken = token || storedToken;

  // The logout endpoint uses AuthGuard, so it must receive the current JWT
  // before the caller clears the local session.
  const headers = {
    Accept: 'application/json',
  };
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const response = await fetch(logoutUrl, {
    method: 'POST',
    headers,
    cache: 'no-store',
  });

  return {
    ok: response.ok,
    status: response.status,
  };
};
